import { styled } from '@mui/material/styles';

import Button from '@mui/material/Button';

const GreyButtonStyled = styled(Button)(({ theme, variant }) => ({
  color: theme.palette.text.primary,
  background: variant === 'contained' ? theme.palette.grey[800] : undefined,
  borderColor: variant === 'outlined' ? theme.palette.grey[800] : undefined,
  '&:hover': {
    background: variant === 'contained' ? theme.palette.grey[700] : undefined,
    borderColor: variant === 'outlined' ? theme.palette.grey[600] : undefined,
  },
}));

export default GreyButtonStyled;
